import { PassouFalhouEnum } from '@mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import {
  hasAnySim,
  isAllNao,
  isPerguntaOutroFilled,
  isPerguntaOutroNao,
  isPerguntaOutroSim,
} from '@mchat-rf/consulta-seguimento/utils-consultaSeguimento'

import {
  ConsultaSeguimentoPergunta17Model,
  ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum,
} from './model-consultaSeguimentoPergunta17'

const pergunta17TentaFazerQueOlheEnum = Object.values(ConsultaSeguimentoPergunta17TentaFazerQueOlheEnum)

export const isPergunta17TentaFazerQueOlheAllNao = (value: ConsultaSeguimentoPergunta17Model): boolean => {
  const isExemplosAllNao = isAllNao(value?.PERGUNTA_17_TENTA_FAZER_QUE_OLHE, pergunta17TentaFazerQueOlheEnum)

  if (isPerguntaOutroFilled(value?.OUTRO)) {
    return isExemplosAllNao && isPerguntaOutroNao(value?.OUTRO)
  }

  return isExemplosAllNao
}

export const hasPergunta17TentaFazerQueOlheAnySim = (value: ConsultaSeguimentoPergunta17Model): boolean => {
  return hasAnySim(value?.PERGUNTA_17_TENTA_FAZER_QUE_OLHE) || isPerguntaOutroSim(value?.OUTRO)
}

export function prunePergunta17(value: ConsultaSeguimentoPergunta17Model): ConsultaSeguimentoPergunta17Model {
  return value
}

export function conditionToCalculatePergunta17(values: ConsultaSeguimentoPergunta17Model): boolean {
  return hasPergunta17TentaFazerQueOlheAnySim(values) || isPergunta17TentaFazerQueOlheAllNao(values)
}

export function calculateResultadoPergunta17(values: ConsultaSeguimentoPergunta17Model): PassouFalhouEnum | undefined {
  if (hasPergunta17TentaFazerQueOlheAnySim(values)) {
    return PassouFalhouEnum.PASSOU
  } else if (isPergunta17TentaFazerQueOlheAllNao(values)) {
    return PassouFalhouEnum.FALHOU
  }
}
